import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateQuoteStatus } from "../apis/updateQuoteStatus";
import type { ApiResponse } from "../../../types/apiResponse";

export const useUpdateQuoteStatus = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, { id_quote: number; status_quote: string }>({
        mutationFn: updateQuoteStatus,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
        },
    });
};
